import React from 'react';
import { useStyles } from './styles';
import { Container, Grid, Typography } from '@mui/material';
import dateFormat from 'dateformat';

const AuthWrapper = ({ children }) => {
    const classes = useStyles();

    const getCurrentYear = () => dateFormat(new Date(), 'yyyy')

    return (
        <div className={classes.bg}>
            <Container>
                <Grid container className={classes.wrapper}>
                    <Grid item xs={12} className={classes.formWrapper}>
                        {children}
                    </Grid>
                </Grid>

                <Typography align="center" className={classes.copyright}>
                    Copyright ©{getCurrentYear()} Servicepipe
                </Typography>
            </Container>
        </div>
    );
};

export default AuthWrapper;
